export default __webpack_public_path__ + "static/media/home-magazine-img-01.03b1150d.jpg";